import { useQuery } from '@tanstack/react-query'

import { Governance } from '../clients/Governance'
import { ProposalAttributes } from '../types/proposals'
import { Vote, VoteSegmentation } from '../types/votes'
import { getVoteSegmentation } from '../utils/votes/utils'

import { DEFAULT_QUERY_STALE_TIME } from './constants'

export const PROPOSAL_CACHED_VOTES_QUERY_KEY = 'proposalsVotes'

function useProposalsCachedVotes(proposalIds: ProposalAttributes['id'][]) {
  const { data: votes, isLoading: isLoadingVotes } = useQuery({
    queryKey: [PROPOSAL_CACHED_VOTES_QUERY_KEY, proposalIds.join('-')],
    queryFn: () => Governance.get().getCachedVotesByProposals(proposalIds),
    staleTime: DEFAULT_QUERY_STALE_TIME,
  })

  const segmentedVotes = votes
    ? Object.entries(votes).reduce((acc, [proposalId, voteMap]) => {
        acc[proposalId] = getVoteSegmentation(voteMap)

        return acc
      }, {} as Record<string, VoteSegmentation<Vote>>)
    : undefined

  return { votes, segmentedVotes, isLoadingVotes }
}

export default useProposalsCachedVotes
